import React, { useEffect, useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { TableBox, SearchFilter, Paging } from '../../components';
import { usePagination, useFilter } from '../../hooks';
import { SnackbarContext } from '../../contexts';
import Button from '@mui/material/Button';
import Handler from '../../Handler';
import API from '../../api';

export const ReductionListPage = (props) => {
  const history = useHistory();
  const location = useLocation()
  const params = new URLSearchParams(location.search);
  const { updateSnackbar } = useContext(SnackbarContext);
  const [list, setList] = useState(null);
  const [header, setHeader] = useState([
    {
      key: 'seq',
      align: 'center',
      text: 'No',
      style: {
        minWidth: 100,
      },
    },
    {
      key: 'project',
      align: 'center',
      text: '사업 ID',
      style: {
        minWidth: 100,
      },
      render: (value) => {
        return value?.id;
      },
    },
    {
      key: 'project',
      align: 'center',
      text: '사업명',
      style: {
        minWidth: 300,
      },
      render: (value) => {
        return (
          <div style={{ maxWidth: 360 }} className='ellipsis-text'>
            <span>{value?.title}</span>
          </div>
        );
      },
    },
    {
      key: 'lastDoc',
      align: 'center',
      text: '발행 수량 (크레딧)',
      style: {
        minWidth: 100,
      },
      render: (value) => {
        return Handler.numberWithCommas(value?.realReduction);
      },
    },
    {
      key: '',
      align: 'center',
      text: '기업명',
      style: {
        minWidth: 100,
      },
      render: (value) => {
        return value?.project?.user?.companyName;
      },
    },
    {
      key: '',
      align: 'center',
      text: '이메일',
      style: {
        minWidth: 100,
      },
      render: (value) => {
        return value?.project?.user.email;
      },
    },
    {
      key: '',
      align: 'center',
      text: '상태',
      style: {
        minWidth: 100,
      },
      render: (value) => {
        switch (value?.lastDoc?.actionSeq.status) {
          case 'WaitingForAuditReductionCert': {
            return (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontSize: 14 }}>
                  {Handler.ENUM.REDUCTION_ACTION.STATUS(value?.lastDoc?.actionSeq.status) +
                    '(' +
                    value.lastDoc.degree +
                    ')'}
                </span>
                <span style={{ fontSize: 12, color: '#777' }}>{Handler.getYYYYMMDDByUnix(value.updatedAt)}</span>
              </div>
            );
          }
          default: {
            return (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontSize: 14 }}>
                  {Handler.ENUM.REDUCTION_ACTION.STATUS(value?.lastDoc?.actionSeq.status)}
                </span>
                <span style={{ fontSize: 12, color: '#777' }}>{Handler.getYYYYMMDDByUnix(value.updatedAt)}</span>
              </div>
            );
          }
        }
      },
    },
  ]);
  const [filter, onFilterChange, setFiler] = useFilter([
    {
      key: 'status',
      type: 'select',
      label: '문서 상태',
      value: 'SELECT_ALL',
      menus: [
        {
          value: 'SELECT_ALL',
          label: '전체',
        },
        {
          label: '임시 저장',
          value: 'Writing',
        },
        {
          label: '심사 대기',
          value: 'Waiting',
        },
        {
          label: '심사중',
          value: 'Audit',
        },
        {
          label: '보완요청',
          value: 'ImprovementRequest',
        },
        {
          label: '최종승인 / 착수승인',
          value: 'Approved',
        },
        {
          label: '최종반려 / 착수반려',
          value: 'Rejected',
        },
        {
          label: '신청취소 / 사업취소',
          value: 'Canceled',
        },
      ],
    },
    {
      key: 'searchType',
      type: 'select',
      label: '검색 종류',
      value: 'Title',
      menus: [
        {
          value: 'Name',
          label: '이름',
        },
        {
          value: 'Email',
          label: '이메일',
        },
        {
          value: 'Title',
          label: '사업명',
        },
        {
          value: 'ProjectId',
          label: '사업 ID',
        },
      ],
    },
    {
      key: 'searchValue',
      type: 'input',
      label: '검색 값',
      value: '',
      inputType: 'text',
    },
  ]);
  const [page, totalPage, totalCount, onPageChange, setPage, setTotalPage, setTotalCount] = usePagination(0, 9);

  const tableCallback = (type, index) => {
    console.log('tableCallback type', type);
    console.log('tableCallback index', index);
  };

  const tableRowClick = (index) => {
    console.log('tableRowClick index', index);
    let target_seq = list[index].seq;
    history.push('/reduction/detail/' + target_seq);
  };

  const onReset = () => {
    setPage(0);
    requestNewList(0, true)
  }

  const onSearch = (body) => {
    requestNewList(0);
  };

  useEffect(() => {
    requestNewList();
    history.replace(`?page=${page}`);
  }, [page]);

  useEffect(() => {
    const page = parseInt(params.get('page') || '0', 9);
    setPage(page);
  }, []);

  const requestNewList = (init_page, isReset = false) => {
    let body = isReset ? null : Handler.filterToBody(filter);
    API.ReductionCert.Get({
      ...body,
      page: init_page ? init_page : page,
      size: Handler.VARIABLES.PAGE_LIMIT,
    }).then(
      (res) => {
        const { content, totalPages } = res.data;
        setList(content);
        setTotalPage(totalPages);
      }).catch(
        (err) => {
          updateSnackbar({
            type: 'error',
            open: true,
            message: err.data.message,
          });
        }
      )
  };

  return (
    <article className='basic-page'>
      <section className='content-header__container'>
        <header>
          <h3>감축량 목록</h3>
        </header>
      </section>
      <section className='filter__container'>
        <SearchFilter data={filter} onChange={onFilterChange} onSearch={onSearch} onReset={onReset}></SearchFilter>
      </section>
      <section className='table__container'>
        <TableBox data={list} header={header} callback={tableCallback} rowClick={tableRowClick}></TableBox>
      </section>
      <section className='paging__container'>
        <Paging page={page} totalPage={totalPage} onChange={onPageChange}></Paging>
      </section>
    </article>
  );
};
